<template>
  <div class="fu-drtab" data-test="fu-drawer-comm">
    <p v-if="!rows.length" class="fu-drtab__empty" data-test="fu-drawer-comm-empty">No commlog entries in Open Dental yet.</p>
    <div v-for="c in rows" :key="c.key" class="fu-drcomm" data-test="fu-drawer-comm-item">
      <div class="fu-drcomm__when">{{ c.when }}</div>
      <div class="fu-drcomm__main">
        <div class="fu-drcomm__head">
          <span class="fu-drcomm__type"><fu-icon :name="c.icon" :size="13" />{{ c.type }}</span>
          <span v-if="c.user" class="fu-drcomm__user">{{ c.user }}</span>
        </div>
        <div class="fu-drcomm__text">{{ c.shown }}</div>
        <button
          v-if="c.long"
          type="button"
          class="fu-drcomm__more"
          :aria-expanded="String(!!open[c.key])"
          data-test="fu-drawer-comm-more"
          @click="toggle(c.key)"
        >{{ open[c.key] ? 'Show less' : 'More' }}</button>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * DrawerCommTab — "Comm log": today's Open Dental commlog rows (CommDateTime, Note, Mode_, UserName)
 * newest first as loaded, with the design's More / Show less on a long note (today: <truncate> at 90
 * characters; here 150). The note is TEXT — never v-html. Mode_ → type as today: 5 Text, 3 Phone,
 * 1 / 2 / 4 / 6 Email. Presentational.
 */
import FuIcon from '../FuIcon.vue';

const LONG = 150;
const TYPE = { 5: ['Text', 'text'], 3: ['Phone', 'phone'], 1: ['Email', 'mail'], 2: ['Email', 'mail'], 4: ['Email', 'mail'], 6: ['Email', 'mail'] };

export default {
  name: 'DrawerCommTab',
  components: { FuIcon },
  props: {
    tab: { type: Object, required: true },
    ctx: { type: Object, required: true },
  },
  data() {
    return { open: {} };
  },
  computed: {
    rows() {
      const s = (this.tab.sections || [])[0];
      return ((s && s.rows) || []).map((r, i) => {
        const t = TYPE[r.Mode_] || ['Note', 'note'];
        const text = r.Note === null || r.Note === undefined ? '' : String(r.Note);
        const long = text.length > LONG;
        const key = `c${i}`;
        return {
          key,
          when: this.ctx.formatDateTime(r.CommDateTime),
          type: t[0],
          icon: t[1],
          user: r.UserName || '',
          long,
          shown: long && !this.open[key] ? `${text.slice(0, LONG - 10).replace(/\s+\S*$/, '')}…` : text,
        };
      });
    },
  },
  methods: {
    toggle(key) {
      this.open = Object.assign({}, this.open, { [key]: !this.open[key] });
    },
  },
};
</script>

<style lang="scss" scoped>
@import './drawer';

.fu-drtab__empty { @include fu-dr-empty; }

.fu-drcomm {
  display: grid;
  grid-template-columns: 96px minmax(0, 1fr);
  gap: 12px;
  padding: 13px 0;
  border-bottom: 1px solid $fu-border;
}

.fu-drcomm__when {
  @include fu-tabular;
  font-size: 12px;
  line-height: 1.45;
  font-weight: $fu-fw-bold;
  color: $fu-neutral-700;
  overflow-wrap: anywhere;
}

.fu-drcomm__main { min-width: 0; }

.fu-drcomm__head {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 5px;
}

.fu-drcomm__type {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  height: 22px;
  padding: 0 8px;
  border-radius: 20px;
  background: $fu-neutral-50;
  border: 1px solid $fu-border;
  font-size: 11.5px;
  font-weight: $fu-fw-bold;
  color: $fu-neutral-600;
}

.fu-drcomm__user { font-size: 12px; color: $fu-text-muted; }

.fu-drcomm__text {
  font-size: 13px;
  line-height: 1.5;
  color: $fu-neutral-700;
  white-space: pre-line;
  overflow-wrap: anywhere;
}

.fu-drcomm__more {
  @include fu-link-btn;
  margin-top: 3px;
  font-size: 12px;
  font-weight: $fu-fw-bold;
}

.fu-dr--phone .fu-drcomm { grid-template-columns: minmax(0, 1fr); gap: 4px; }
</style>
